<div class="snack-container box-{{ getIcon?.type }}">
  <div
    class="snack-container-desc-icon align-self-center"
    [class]="getIcon?.icon"
  >
    <mat-icon>{{ getIcon?.icon }}</mat-icon>
  </div>

  <div class="message align-self-center">
    <span>{{ data.message }}</span>
  </div>

  <div class="snack-container-cross-icon align-self-center">
    <mat-icon class="pointer-cursor" (click)="closeSnackbar()">close</mat-icon>
  </div>
</div>
